import { render, staticRenderFns } from "./exemption.vue?vue&type=template&id=24eaac7a"
import script from "./exemption.vue?vue&type=script&lang=js"
export * from "./exemption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports